export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/youtube', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getYoutubeList = async (searchText) => {
    try {
        const result = await get(`youtube${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getYoutubeContent = async (newsId) => {
    try {
        const result = await get(`youtube/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createYoutube = async (data) => {
    try {
        const result = await post('youtube', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateYoutube = async (id, data) => {
    try {
        const result = await put(`youtube/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteYoutube = async (id) => {
    try {
        const result = await destroy(`youtube/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`youtube/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const subscribeUser = async (id) => {
//     try {
//         const result = await put(`payment/admin/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const getUserCount = async () => {
//     try {
//         const result = await get(`users/count`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
